import { Button } from 'base/ui/button';
import { Dialog } from 'base/ui/dialog';
import { Rows } from 'base/ui/layout';
import { TextSmallLight, Title5 } from 'base/ui/typography';
import React from 'react';
import { EditorMode } from '../editor_mode';
import styles from './dialog.css';

/** Shows the onboarding dialog if the user hasn't seen it yet. */
export function MaybeOnboardingDialog({
  isNewProject,
  isExperiment,
  currentMode,
}: {
  isNewProject: boolean;
  isExperiment: boolean;
  currentMode: EditorMode;
}) {
  const [dismissed, setDismissed] = React.useState(false);
  const close = React.useCallback(() => setDismissed(true), []);

  const open =
    isNewProject &&
    !hasSeenOnboarding() &&
    currentMode !== EditorMode.Styleguide &&
    !isExperiment &&
    !dismissed;

  React.useEffect(() => {
    if (dismissed) setHasSeenOnboarding();
  }, [dismissed]);

  if (!open) return null;
  return <OnboardingDialog onClose={close} mute={true} />;
}

const storageKey = 'relumeBlocksHasSeenOnboarding';
function hasSeenOnboarding() {
  return localStorage.getItem(storageKey) === 'true';
}
function setHasSeenOnboarding() {
  localStorage.setItem(storageKey, 'true');
}

export function OnboardingDialog({
  onClose,
  mute,
}: {
  onClose: () => void;
  mute: boolean;
}) {
  return (
    <Dialog title={undefined} onClose={onClose}>
      <iframe
        ref={mute ? null : focusOnMount}
        className={styles.videoInline}
        src={
          'https://www.youtube.com/embed/VrBFf71ySGw?modestbranding=1&autoplay=1' +
          (mute ? '&mute=1&cc_load_policy=1' : '')
        }
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
      />
      <Rows spacing={8}>
        <Title5>Welcome to Site Builder</Title5>
        <TextSmallLight>
          Build a Sitemap and Wireframe in minutes with the help of AI. Easily
          export to Figma and Webflow once you’re done.
        </TextSmallLight>
      </Rows>
      <Button
        variant="primary"
        size="large"
        onClick={onClose}
        label="Start Building"
      />
    </Dialog>
  );
}

function focusOnMount(el: HTMLElement | null) {
  el?.focus();
}
